export default __webpack_public_path__ + "static/media/contact_img.71e7c687.jpg";